import { render, staticRenderFns } from "./ChartTimeFrames.vue?vue&type=template&id=280ec35a&scoped=true&"
import script from "./ChartTimeFrames.vue?vue&type=script&lang=js&"
export * from "./ChartTimeFrames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ec35a",
  null
  
)

export default component.exports